var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-badge",style:(`
    --color: ${_vm.color};
    --width: ${_vm.width}px;
    --height: ${_vm.height}px;
  `)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }